module.exports = __webpack_public_path__ + "img/waicon.83ed00ee.png";